import React, { useState , useRef, useEffect, useCallback} from 'react';

import styles from './searchbar.module.css';

import { MdPushPin } from "react-icons/md";
      
import { useGlobalState } from '../../../../global_state_components/GlobalStateProvider';

import { MdOutlinePushPin } from "react-icons/md";
import { axiosInstance } from '../../../../../lib/axiosInstance';
import SimpleBar from 'simplebar-react';
import 'simplebar-react/dist/simplebar.min.css';


function Searchbar(props) {
  const {subject, setSubjectFn, allSubjects, setAllSubjects, pinnedSubjects, setPinnedSubjects, subjectSearchbarInputRef} = useGlobalState();


  useEffect(() => {
    //console.log('Searchbar component rendered');
  });


  //-----------Display subject expansion box or not  (Down)---------------------
  
  const [clickedExpand, setClickedExpand] = useState(false);
  function handleSubjectExpansion(){
    if (clickedExpand===false){
      setClickedExpand(true);
    }else if (clickedExpand===true){
      setClickedExpand(false);
    }
  }

  //---
  // After adding the below it seems like it is taking too much time to load when you run "npm start".
  
  const subjectExpansionBoxRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (subjectExpansionBoxRef.current && !subjectExpansionBoxRef.current.contains(event.target) && !subjectSearchbarInputRef.current.contains(event.target)) {
        // Clicked outside the component
        //console.log('Clicked outside!');
        setClickedExpand(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);

    return () => {                                                    //  Didn't understand what this is for.
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  //---------------------Display subject expansion or not (up)-----------------------





  //----searchTerm change handling--------------------
  const [searchTerm, setSearchTerm] = useState('');

  const [filteredSubjects, setFilteredSubjects] = useState([]);

  useEffect(() => {
    async function fetchSubjects() {
      try {
        const response = await axiosInstance.get('/subjects/search?query'); //Loaded with the entire subjects.
        const subjects = response.data.map(item => item.subject_name);
        setAllSubjects(subjects);
        setFilteredSubjects(subjects);
      } catch (error) {
        console.log("sss : "+error);
        setFilteredSubjects([]); //If the subjects are not loaded, then set an empty array.
      }
    }
  
    fetchSubjects();
  }, []);



  const handleSearchChange = async (event) => {
    setSearchTerm(event.target.value);

    const searchValueInLowerCase = event.target.value.toLowerCase();

    if (clickedExpand===true){
      try{
        const response = await axiosInstance.get(`/subjects/search?query=${searchValueInLowerCase}`); //If nothing is found, then it returns the entire subjects.
        //console.log("search subjects res : "+JSON.stringify(response.data));
        if (response.data.length === 0){
          //console.log("No subjects found.");
          setFilteredSubjects([]);
        }else{
          const subjects = response.data.map(item => item.subject_name);
          setFilteredSubjects(subjects);
        }
  
      }catch(error){
        console.log(error);
      }
    }

  };




  //-------------------Handle pinning and unpinning subjects-------------------
  async function handleUnpinPinnedSubjects(s){
    try{
      if (pinnedSubjects.length >1){
        //setPinnedSubjects(pinnedSubjects.filter(item=>item!==s));
        const profileResponse = await axiosInstance.patch('/profile', {favouriteSubjects: pinnedSubjects.filter(item=>item!==s)});
        //console.log("Subject Unpin - Profile update response:", profileResponse.data);
        getPinnedSubjectsFromProfileDetails();
      }
    }catch(error){
      console.log(error);
    }
  }
  
  async function handlePinSubjects(s){
    try{
      if (!pinnedSubjects.includes(s) && pinnedSubjects.length < 5){
        const profileResponse = await axiosInstance.patch('/profile', {favouriteSubjects: [...pinnedSubjects, s]});
        //console.log("Subject Pin - Profile update response:", profileResponse.data);
        getPinnedSubjectsFromProfileDetails();
        //setPinnedSubjects([...pinnedSubjects, s]);
      }
    }catch(error){
      console.log(error);
    }
  }
  
  
  //To fetch the existing profile details if any.
  async function getPinnedSubjectsFromProfileDetails() {
    try {
      const response = await axiosInstance.get('/profile');
      
      setPinnedSubjects(response.data.favouriteSubjects); // Set the fetched profile details in the state. favouriteSubjects is an array of strings.
    } catch (error) {
      console.error("Failed to fetch default image:", error); // Log error details

      if (error.response) {
        console.log("Error Data: ", error.response.data);
      }
    }
  }

  useEffect(() => {
    getPinnedSubjectsFromProfileDetails(); // Call the async function inside useEffect
  }, []); // Empty dependency array ensures the effect runs only once
  
  



  //----addTerm change handling--------------------
  const [addTerm, setAddTerm] = useState('');

  const handleAddChange = (event) => {
    setAddTerm(event.target.value);
  };
  




  //---------addTerm handling --------------------
  function handleUserAddedSubjects(){     //Is add request better (and we accept that) than letting users add subjects?
    if (!allSubjects.includes(addTerm.trim())){
      //console.log("i am hereeeeeeeeeeeeeeeee.")
      axiosInstance.post('/subjects/add', { subject_name: addTerm.trim() })
        .then(response => {
          //console.log("Subject added successfully:", response.data);
          setAddTerm('');
        })
        .catch(error => {
          console.error("Failed to add subject:", error);
        });
    }
  }

  function handlePermanentAddedSubjects(){     //Is add request better (and we accept that) than letting users add subjects?
    if (!allSubjects.includes(addTerm.trim())){
      //Do if any.
    }
  }




  //-------------return---------------
  //update the bottom component as 3 components.
  return(
    <div style={{marginRight: props.marginRightProp}} className={styles.searchbar_main_div}>
      <input
        type="search"
        placeholder="Search..."
        value={searchTerm}
        onChange={handleSearchChange}
        className={styles.search_input}
        ref={subjectSearchbarInputRef}
        
        onClick={handleSubjectExpansion}
      />

      {(clickedExpand===true)&&(<div ref={subjectExpansionBoxRef} className={styles.subject_expansion_box}>
                                  
                                  <p className={styles.pin_daily_subjects_p_tag}>Pin your daily subjects here. You can pin upto 5 disciplines.</p>
                                  
                                  {/*------------pinnedSubjects-------------*/}
                                  <SimpleBar 
                                    className={styles.pinned_div_simplebar}     
                                    autoHide={false}
                                  >
                                    <div className={styles.pinned_div}>
                                      {pinnedSubjects.map(function(eachPinnedSubject, index){
                                        return(
                                          <div 
                                            onClick={
                                              (e)=>{e.stopPropagation(); 
                                              setSubjectFn(eachPinnedSubject);}
                                            } 
                                            key={index} 
                                            className={styles.expansion_box_subject}
                                          >
                                            <MdPushPin 
                                              onClick={
                                                (e)=>{
                                                  e.stopPropagation(); 
                                                  handleUnpinPinnedSubjects(eachPinnedSubject);
                                                }
                                              } 
                                              className={styles.pinned}
                                            />
                                            {eachPinnedSubject}
                                          </div>
                                        )
                                        })
                                      }
                                    </div>
                                  </SimpleBar>

                                  {/*------------Line-------------*/}

                                  <hr className={styles.expansion_box_hr}></hr>

                                  {/*------------Not pinned subject div-------------*/}
                                  <SimpleBar 
                                    className={styles.not_pinned_div_simplebar}     
                                    autoHide={false}
                                  >
                                    <div className={styles.not_pinned_div}>

                                      {filteredSubjects.map(function(eachSubject, index){
                                        return(
                                          <div 
                                            onClick={
                                              (e)=>{
                                                e.stopPropagation(); 
                                                setSubjectFn(eachSubject);
                                              }
                                            } 
                                            key={index} 
                                            className={styles.expansion_box_subject}
                                          >
                                            <MdOutlinePushPin 
                                              onClick={
                                                (e)=>{
                                                  e.stopPropagation(); 
                                                  handlePinSubjects(eachSubject);
                                                }
                                              } 
                                              className={styles.not_pinned}
                                            />
                                            {eachSubject}
                                          </div>
                                        )
                                        })
                                      }
                                    </div>
                                  </SimpleBar>

                                  {/*------------subject add div-------------*/}

                                  <div className={styles.subject_add_div}>
                                    {/* <div onClick={()=>{handlePermanentAddedSubjects()}} className={styles.subject_add_button}>
                                      Permanent add
                                    </div> */}
                                    <input
                                      type="text"
                                      placeholder="Add a discipline if not available above..."
                                      value={addTerm}
                                      onChange={handleAddChange}
                                      className={styles.add_input}
                                    />
                                    <div onClick={()=>{handleUserAddedSubjects()}} className={styles.subject_add_button}>
                                      Add
                                    </div>
                                  </div>

                                </div>)}
    </div>
  )

}


export default Searchbar;













